import React from "react";
import GrowNetwork from "../../components/service-pages/grow-network/GrowNetwork";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { getRouteLocalizationNamespaces } from "../../methods/getRouteLocalizationNamespaces";
import { FaqsResponse } from "@vahak/core/dist/_services/faq.service";
import {
    getGrowNetworkPageLayout,
    getGrowNetworkStaticProps
} from "../../components/service-pages/constants/growNetwork-constants-methods";

export default function GrowNetworkPage({ faqs }: { faqs: FaqsResponse[] }) {
    return <GrowNetwork faqs={faqs} />;
}

GrowNetworkPage.getLayout = getGrowNetworkPageLayout;

export async function getStaticProps({ locale }: any) {
    return {
        props: {
            isMobile: false,
            ...(await getGrowNetworkStaticProps()),
            ...(await serverSideTranslations(locale, getRouteLocalizationNamespaces("servicePages")))
        }
    };
}
